<template>
  <div>
    <!-- HERO -->
    <div class="hero">
      <!-- LEFT CONTENT -->
      <div class="hero-left">
        <h1>
          {{ $t("message.hero_title1") }}
        </h1>

        <p>
          {{ $t("message.hero_description1") }}<br />
          {{ $t("message.hero_description2") }}
        </p>

        <div class="buttons">
          <button
            class="btn btn-secondary"
            @click="showGuideModal = true"
          >
            {{ $t("message.hero_guide_button") }}
          </button>

          <button
            class="btn btn-primary"
            @click="showTravelerModal = true"
          >
            {{ $t("message.hero_traveler_button") }}
          </button>
        </div>

        <div class="early-access">
          🎉 {{ $t("message.hero_description3") }}
        </div>
      </div>

      <!-- RIGHT IMAGE -->
      <div class="hero-right">
        <img
          src="@/assets/images/Home.jpg"
          alt="Hero image"
        />
      </div>
    </div>

    <!-- MODALS -->
    <GuideModal
      v-if="showGuideModal"
      @close="showGuideModal = false"
    />

    <TravelerModal
      v-if="showTravelerModal"
      @close="showTravelerModal = false"
    />
  </div>
</template>

<script>
import GuideModal from "./GuideModal.vue";
import TravelerModal from "./TravelerModal.vue";

export default {
  components: {
    GuideModal,
    TravelerModal
  },
  data() {
    return {
      showGuideModal: false,
      showTravelerModal: false
    };
  }
};
</script>

<style scoped>
/* =========================
   HERO BASE
========================= */
.hero {
  display: flex;
  min-height: 100vh;
  padding-top: 60px; /* ✅ FIX for fixed navbar */
  background: #0f3d3a;
  color: #ffffff;
}

/* =========================
   LEFT CONTENT
========================= */
.hero-left {
  flex: 0 0 50%;
  padding: 80px 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.hero-left h1 {
  font-size: 48px;
  line-height: 1.2;
  margin-bottom: 24px;
}

.hero-left p {
  font-size: 18px;
  max-width: 420px;
  margin-bottom: 32px;
  line-height: 1.6;
}

/* Buttons */
.buttons {
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
}

.btn {
  padding: 14px 28px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 16px;
}

.btn-primary {
  background: #e6f2ef;
  color: #0f3d3a !important;
}

.btn-secondary {
  background: #4f6f6c;
  color: #ffffff;
}

.early-access {
  font-size: 14px;
  opacity: 0.85;
}

/* =========================
   RIGHT IMAGE (DESKTOP)
========================= */
.hero-right {
  flex: 0 0 50%;
  position: relative;
  overflow: hidden;
}

.hero-right img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* =========================
   MOBILE FIXES
========================= */
@media (max-width: 900px) {
  .hero {
    flex-direction: column;
    min-height: auto;
  }

  /* Image FIRST on mobile */
  .hero-right {
    order: 1;
    position: relative;
    height: 260px; /* ✅ ensures image is visible */
    flex: none;
  }

  .hero-right img {
    position: relative;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  /* Content SECOND */
  .hero-left {
    order: 2;
    padding: 32px 24px 40px;
  }

  .hero-left h1 {
    font-size: 32px;
  }

  .buttons {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}
</style>
